import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "antd";

const LogoutButton = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  return (
    <Button
      type="primary"
      onClick={handleLogout}
      style={{
        borderRadius: 999,
        padding: "0 18px",
        height: 38,
        fontWeight: 600,
        border: "none",
        background: "linear-gradient(90deg, #38bdf8, #6366f1)",
        boxShadow: "0 8px 18px rgba(56, 189, 248, 0.35)",
      }}
    >
      Se déconnecter
    </Button>
  );
};

export default LogoutButton;
